import React from 'react';
import { usePartnersList } from '../hooks/use-partners-list.js';
import PartnersPageView from './partners-page-view.jsx';

function PartnersPageContainer() {
  const state = usePartnersList();
  return <PartnersPageView {...state} />;
}

export default PartnersPageContainer;
